<template>
  <label :class="['ui-switch', {
    'usw-sm': getSize === 'small',
    'usw-md': getSize === 'medium',
    'usw-lg': getSize === 'large',
    'usw-on': (inverted ? !model : model)
  }, props.disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer']">
    <input v-show="false" type="checkbox" v-model="model" :disabled="props.disabled" />
    <div :class="['usw-dot', inverted ? !model : model ? 'text-green-400' : 'text-neutral-400']">
      <UiIcon v-if="useIcons" :icon="model ? onIcon : offIcon" :size="{
        small: 8,
        medium: 12,
        large: 20
      }[getSize]"
      />
    </div>
  </label>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import UiIcon from '@/components/ui/icon.vue'

const props = withDefaults(defineProps<{
  disabled?: boolean
  size?: 'small' | 'medium' | 'large'
  inverted?: boolean
  useIcons?: boolean
  onIcon?: string
  offIcon?: string
  beforeChange?: any
}>(), {
  useIcons: false,
  onIcon: 'player-play-filled',
  offIcon: 'player-pause-filled'
})

const model = defineModel<boolean>()

const getSize = computed(() => {
  const sz = (props.size || '').toLowerCase()
  if (['small', 'medium', 'large'].includes(sz)) return sz
  return 'medium'
})
</script>

<style scoped lang="scss">
.ui-switch {
  display: inline-flex;
  align-items: center;
  padding: 0.125rem;
  transition: all 0.3s ease-in-out;
  flex-shrink: 0;
  background-color: #d1d5db;

  &.usw-on {
    background-color: #34d399;
  }

  &.usw- {
    &sm {
      width: 2rem;
      height: 1rem;
      border-radius: 1rem;
    }
    &md {
      width: 2.5rem;
      height: 1.25rem;
      border-radius: 1.25rem;
    }
    &lg {
      width: 4rem;
      height: 2rem;
      border-radius: 2rem;
    }
  }

  .usw-dot {
    background-color: #ffffff;
    border-radius: 100%;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateX(0);    
  }

  &.usw-sm {
    .usw-dot {
      width: 0.75rem;
      height: 0.75rem;
    }
    &.usw-on .usw-dot {
      transform: translateX(1rem);
    }
  }

  &.usw-md {
    .usw-dot {
      width: 1rem;
      height: 1rem;
    }
    &.usw-on .usw-dot {
      transform: translateX(1.25rem);
    }
  }

  &.usw-lg {
    .usw-dot {
      width: 1.75rem;
      height: 1.75rem;
    }
    &.usw-on .usw-dot {
      transform: translateX(2rem);
    }
  }
}
</style>